<script setup lang="ts">
import { useDialog } from '@/core/composables/useDialog'

const { dialog, closeDialog } = useDialog()

defineOptions({
  name: 'DialogManager'
})
</script>

<template>
  <Teleport to="#app">
    <component
      :is="dialog.component"
      v-if="dialog"
      :key="dialog.id"
      v-bind="{ ...dialog.props, ...dialog.listeners }"
      @close="closeDialog"
    />
  </Teleport>
</template>
